import { render, staticRenderFns } from "./createStaffPopup.vue?vue&type=template&id=40417dd0&scoped=true&"
import script from "./createStaffPopup.vue?vue&type=script&lang=js&"
export * from "./createStaffPopup.vue?vue&type=script&lang=js&"
import style0 from "./createStaffPopup.vue?vue&type=style&index=0&id=40417dd0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40417dd0",
  null
  
)

export default component.exports